import { Button } from "@/components/ui/button";

interface ChamadosAbertosCardProps {
  title?: string;
  buttonLabel?: string;
  onClick?: () => void;
}

export default function ChamadosAbertosCard({
  title = "Chamados abertos",
  buttonLabel = "Ver todos",
  onClick,
}: ChamadosAbertosCardProps) {
  return (
    <div className="bg-white rounded-[20px] py-4 px-6 flex items-center justify-between gap-4">
      <span className="text-lg font-semibold text-n-green">{title}</span>

      <Button variant="green" type="button" size="sm" onClick={onClick}>
        {buttonLabel}
      </Button>
    </div>
  );
}
